// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__-WCw8","info":"UpdateTermsInfo_info__1GH8U"};